import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Footer from '../../base/components/Footer'

export default class ProgramContainer extends Component {

  static propTypes = {
    children: PropTypes.node
  }

  render() {
    return (
      <div className="container-fluid vertical content">
        {this.props.children}
        <Footer />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/frontend/guided-tour/containers/Container.js